export default __webpack_public_path__ + "static/media/tabpassword.c3035d9b.svg";